import React from 'react';
import Logo from '../components/Logo';
import HomeDropdown from '../components/HomeDropdown';
import NavLinks from '../components/NavLinks';
import JoinButton from '../components/JoinButton';

const OverlayNav = ({ 
  currentPage, 
  showLogo = true, 
  showJoinButton = true,
  dropdownVisible,
  activeDropdownItem,
  onToggleDropdown,
  onItemClick,
  className = ''
}) => {
  return (
    <div className={`nav-container ${className}`}>
      <nav className="nav-main" role="navigation" aria-label="Main navigation">
        {showLogo && <Logo variant="overlay" />}
        
        <ul className="nav-links-overlay">
          <HomeDropdown 
            currentPage={currentPage}
            variant="overlay"
            dropdownVisible={dropdownVisible}
            activeDropdownItem={activeDropdownItem}
            onToggleDropdown={onToggleDropdown}
            onItemClick={onItemClick}
          />
          <NavLinks 
            currentPage={currentPage}
            variant="overlay"
          />
        </ul>

        {showJoinButton && (
          <JoinButton 
            variant="overlay" 
            className="nav-item"
          />
        )}
      </nav>
    </div>
  );
};

export default OverlayNav;